import { GET, PATCH, POST } from "../config/axios.config";
import { normalizeReview, normalizeReviews } from "./normalizers";

/**
 * v2 reviews hang off an order (not off a kitchen id), rate on a three-value
 * scale, and require at least 20 characters of written feedback.
 */

export const listKitchenReviews = async (chefId, { page = 1, limit = 20 } = {}) => {
  const res = await GET(`/reviews/chef/${chefId}`, { params: { page, limit } });
  return normalizeReviews(res?.data);
};

export const listFoodReviews = async (foodId, { page = 1, limit = 20 } = {}) => {
  const res = await GET(`/reviews/food/${foodId}`, { params: { page, limit } });
  return normalizeReviews(res?.data);
};

export const listMyReviews = async () => {
  const res = await GET("/reviews/me");
  return normalizeReviews(res?.data?.reviews);
};

/** The overall review a given order already has, or null. */
export const getMyOrderReview = async (orderId) => {
  try {
    const res = await GET(`/reviews/me/order/${orderId}`);
    const result = res?.data?.review;
    return result?.overall ? normalizeReview(result.overall) : null;
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
};

export const submitReview = async ({ orderId, rating, content, facets, problems, photos }) => {
  const res = await POST("/reviews", {
    orderId,
    rating,
    content,
    ...(facets ? { facets } : {}),
    ...(problems?.length ? { problems } : {}),
    ...(photos?.length ? { photos } : {}),
  });
  return { ...res, data: normalizeReview(res?.data?.overall) };
};

export const updateReview = async (reviewId, { rating, content }) => {
  const res = await PATCH(`/reviews/${reviewId}`, {
    ...(rating ? { rating } : {}),
    ...(content ? { content } : {}),
  });
  return { ...res, data: normalizeReview(res?.data?.review) };
};
